import React, { useState, useRef } from 'react';
import './NewCategoria.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faUpload, faImage, faTimes } from '@fortawesome/free-solid-svg-icons';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import baseURL from '../../url';
import { adminFetch } from '../../../utils/api';

export default function NewCategoria({ cargarCategoria }) {
    const [mensaje, setMensaje] = useState('');
    const [categoria, setCategoria] = useState('');
    
    // Estados imagen
    const [imagenFile, setImagenFile] = useState(null);
    const [previewUrl, setPreviewUrl] = useState('');
    const fileInputRef = useRef(null);

    // Descuentos
    const [discountOne, setDiscountOne] = useState(0);
    const [discountTwo, setDiscountTwo] = useState(0);
    const [discountThree, setDiscountThree] = useState(0);
    const [discountFour, setDiscountFour] = useState(0);
    
    const [modalOpen, setModalOpen] = useState(false);

    const toggleModal = () => {
        if (!modalOpen) limpiarFormulario();
        setModalOpen(!modalOpen);
    };

    const limpiarFormulario = () => {
        setCategoria('');
        setImagenFile(null);
        setPreviewUrl('');
        setDiscountOne(0);
        setDiscountTwo(0);
        setDiscountThree(0);
        setDiscountFour(0);
        setMensaje('');
        if(fileInputRef.current) fileInputRef.current.value = "";
    };

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if (file) {
            setImagenFile(file);
            setPreviewUrl(URL.createObjectURL(file));
        }
    };

    const crear = async () => {
        if (!categoria.trim()) {
            toast.warning("El nombre de la categoría es obligatorio");
            return;
        }

        const formData = new FormData();
        formData.append('categoria', categoria);
        if (imagenFile) formData.append('imagen', imagenFile);
        formData.append('discountOne', discountOne);
        formData.append('discountTwo', discountTwo);
        formData.append('discountThree', discountThree);
        formData.append('discountFour', discountFour);

        setMensaje('Guardando...');

        try {
            const response = await adminFetch(`${baseURL}/api/admin/categorias`, {
                method: 'POST',
                body: formData,
            });
            const data = await response.json();

            if (data.mensaje) {
                toast.success(data.mensaje);
                toggleModal();
                if (cargarCategoria) cargarCategoria();
            } else {
                toast.error(data.error || "Error al crear");
            }
        } catch (error) {
            console.error(error);
            toast.error("Error de conexión");
        } finally {
            setMensaje('');
        }
    };

    return (
        <div className="NewCategoria-container">
            <button className='btn-new-cat' onClick={toggleModal}>
                <FontAwesomeIcon icon={faPlus} /> Nueva Categoría
            </button>

            {modalOpen && (
                <div className='modal-overlay'>
                    <div className='modal-card'>
                        <div className='modal-header-new'>
                            <h3>Crear Categoría</h3>
                            <button className='btn-close' onClick={toggleModal}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <div className='modal-body-scroll'>
                            <form className='form-layout'>
                                
                                {/* SECCIÓN SUPERIOR: IMAGEN Y NOMBRE */}
                                <div className='top-section'>
                                    {/* Lado Izquierdo: Imagen */}
                                    <div className='image-upload-wrapper'>
                                        <div className='preview-box' onClick={() => fileInputRef.current.click()}>
                                            {previewUrl ? (
                                                <img src={previewUrl} alt="Preview" className='img-preview-full' />
                                            ) : (
                                                <div className='placeholder-content'>
                                                    <FontAwesomeIcon icon={faImage} size="2x" />
                                                    <span>Seleccionar</span>
                                                </div>
                                            )}
                                        </div>
                                        <input 
                                            type="file" 
                                            accept="image/*" 
                                            ref={fileInputRef}
                                            style={{ display: 'none' }}
                                            onChange={handleFileSelect}
                                        />
                                        <button type="button" className='btn-select-file' onClick={() => fileInputRef.current.click()}>
                                            <FontAwesomeIcon icon={faUpload} /> Subir
                                        </button>
                                    </div>

                                    {/* Lado Derecho: Nombre */}
                                    <div className='name-input-wrapper'>
                                        <label className='input-label'>Nombre de la Categoría</label>
                                        <input
                                            type='text'
                                            className='form-input-main'
                                            placeholder='Ej: Ropa de Invierno'
                                            value={categoria}
                                            onChange={(e) => setCategoria(e.target.value)}
                                            autoFocus
                                        />
                                    </div>
                                </div>

                                {/* SECCIÓN INFERIOR: DESCUENTOS */}
                                <div className='discounts-section'>
                                    <span className='section-title'>Configuración de Precios / Mayoreo</span>
                                    <div className='grid-discounts'>
                                        <div className='discount-group'>
                                            <label>Desc. Nivel 1</label>
                                            <input type='number' value={discountOne} onChange={(e) => setDiscountOne(e.target.value)} />
                                        </div>
                                        <div className='discount-group'>
                                            <label>Desc. Nivel 2</label>
                                            <input type='number' value={discountTwo} onChange={(e) => setDiscountTwo(e.target.value)} />
                                        </div>
                                        <div className='discount-group'>
                                            <label>Desc. Nivel 3</label>
                                            <input type='number' value={discountThree} onChange={(e) => setDiscountThree(e.target.value)} />
                                        </div>
                                        <div className='discount-group'>
                                            <label>Desc. Nivel 4</label>
                                            <input type='number' value={discountFour} onChange={(e) => setDiscountFour(e.target.value)} />
                                        </div>
                                    </div>
                                </div>

                                <div className='modal-actions'>
                                    <button type='button' className='btn-cancel' onClick={toggleModal}>Cancelar</button>
                                    {mensaje ? (
                                        <button type='button' className='btnLoading' disabled>{mensaje}</button>
                                    ) : (
                                        <button type='button' onClick={crear} className='btnPost'>Guardar</button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
            <ToastContainer />
        </div>
    );
}